import { all } from 'redux-saga/effects';
import consultaToxicologicoSaga from './consultaToxicologico/saga';

export default all([consultaToxicologicoSaga]);
